import { defineStore } from 'pinia'
import { ref } from 'vue'
import { sdk } from '@/graphql/client'
import { useTicketsStore } from './tickets'
import { useMessagesStore } from './messages'
import { useAuthStore } from './auth'

export interface QueueItem {
    ticketsetId: number
    code: string
    isOnline: false
    checkpoint?: number
    zoneIds?: number[]
}

export const useQueueStore = defineStore('queue', () => {
    const sendQueue = ref<QueueItem[]>([])
    const sending = ref(false)

    function enqueue(item: QueueItem) {
        const exists = sendQueue.value.some(q => q.code === item.code && q.ticketsetId === item.ticketsetId)
        if (!exists) {
            sendQueue.value = [...sendQueue.value, item]
        }
    }

    function removeFromQueue(item: QueueItem) {
        const messagesStore = useMessagesStore()
        messagesStore.markSent(item.code, item.ticketsetId)
        sendQueue.value = sendQueue.value.filter(q => !(q.code === item.code && q.ticketsetId === item.ticketsetId))
    }

    async function flushQueue() {
        if (sending.value) return
        if (sendQueue.value.length === 0) return

        sending.value = true
        const item = sendQueue.value[0]
        const ticketsStore = useTicketsStore()
        const messagesStore = useMessagesStore()

        try {
            const result = await sdk.TicketUse({
                ticketsetId: item.ticketsetId,
                code: item.code
            })
            const data = result.mobile?.ticketUse
            sending.value = false
            if (data?.ok) {
                const authStore = useAuthStore()
                ticketsStore.useCode({
                    ticketsetId: item.ticketsetId,
                    code: item.code,
                    usedByName: authStore.user?.name ?? null
                })
                removeFromQueue(item)
                void flushQueue()
            } else {
                removeFromQueue(item)
                messagesStore.addMessage({
                    type: 'not-found',
                    message: `CHYBA ODESILANI ${item.code} - ${data?.message ?? ''}`
                })
            }
        } catch {
            sending.value = false
        }
    }

    function clear() {
        sendQueue.value = []
        sending.value = false
    }

    return { sendQueue, sending, enqueue, removeFromQueue, flushQueue, clear }
})
